import { useCallback } from 'react';
import { useEmployerProfileStore } from '../../EmployerProfile.store';

export const useOnContactsClick = () => {
	const { setCurrentTabTo } = useEmployerProfileStore();
	const onContactsClick = useCallback(() => setCurrentTabTo.contacts(), [setCurrentTabTo]);

	return onContactsClick;
};
